import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Divider } from "@material-ui/core";
import React from "react";
import { filter } from "lodash";

const DashboardAccordion = ({ title, icon, formTypes = [], dashboardData = [], classes, linkTo, currentFormType, isAccordion = true }) => {
  //   const filteredData = Object.entries(dashboardData || {})
  //     ?.filter((item) => item?.[0] == currentFormType)
  //     .flat();
  const filteredData = currentFormType ? dashboardData[currentFormType] : dashboardData;
  console.log("filteredFromDashboardAcc", dashboardData, dashboardData[currentFormType], filteredData);

  //   if (filteredData.length === 0) return null;

  return (
    <Accordion className={classes.accordion}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<ExpandMore style={{ color: "white" }} />}
        aria-controls="manage-application-content"
        id={`accordion-${title}`}
      >
        <Link to={!isAccordion && linkTo} className={classes.accordionLink} activeClassName="active">
          <Typography className={classes.accordionHeader}>
            <span style={{ marginRight: "3px" }}>{icon}</span>
            {title}
          </Typography>
        </Link>
      </AccordionSummary>
      {filteredData?.length > 0 && isAccordion && (
        <AccordionDetails 
        className={"accordionDetailNew"}
        >
          {filteredData?.map((item) => {
            const redirectUrl = currentFormType
              ? `/digit-ui/employee/obps/dashboardui/table/${currentFormType}/${item.label}/planningPermission`
              : `/digit-ui/employee/obps/dashboardui/table/${item.label}/professional`;

            return (
              <React.Fragment key={item.action}>
                <Link to={linkTo ? linkTo : redirectUrl} 
                // className={classes.accordionLink}
                 activeClassName="active">
                  {item.action} ({item.count})
                </Link>
                <Divider />
              </React.Fragment>
            );
          })}
        </AccordionDetails>
      )}
    </Accordion>
  );
};
export default DashboardAccordion;
